export default {
    methods: {
        fmt1(value)
        { 
          

          if(!isNaN(value))
          {
            return Number(value).toLocaleString('it-IT',{ style: 'decimal',minimumFractionDigits: 2 ,maximumFractionDigits: 2,useGrouping: true});
          }
        },
        fmt2(value)
        { 
          if(!isNaN(value))
          {
          return Number(value).toLocaleString('it-IT',{ style: 'decimal',minimumFractionDigits: 0 ,maximumFractionDigits: 0,useGrouping: true});
          }
        }, 
        fmt3(value)
        {

           const formatted = new Intl.NumberFormat('it-IT', {
              style: 'percent',
              minimumFractionDigits: 0
          }).format(value / 100)
          return formatted

        },
        fmtDate()
        {
         
          const event = new Date(Date.now());
          
          const fmtDate = event.toLocaleString()
          return fmtDate
        }
    }


    

}